<div [formGroup]="form" fxLayout="column">
  <div fxLayout="row" fxLayoutGap="10px">
    <mat-form-field>
      <mat-label>Start Date</mat-label>
      <input
        matInput
        formControlName="startDate"
        [matDatepicker]="startDatePicker"
        [min]="minDate"
        [max]="maxDate"
        required
      />
      <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #startDatePicker></mat-datepicker>
      <mat-error *ngIf="form.controls.startDate.hasError('matDatepickerMin')"
        >Start date is too far in the past.</mat-error
      >
      <mat-error *ngIf="form.controls.startDate.hasError('matDatepickerMax')"
        >Start date must be on or before today.</mat-error
      >
    </mat-form-field>
    <mat-form-field>
      <mat-label>End Date</mat-label>
      <input
        matInput
        formControlName="endDate"
        [min]="minEndDate"
        [max]="maxDate"
        [matDatepicker]="endDatePicker"
      />
      <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #endDatePicker></mat-datepicker>
      <mat-error *ngIf="form.controls.endDate.hasError('matDatepickerMax')"
        >End date must be on or before today.</mat-error
      >
      <mat-error *ngIf="form.controls.endDate.hasError('matDatepickerMin')"
        >End date must on or after start date.</mat-error
      >
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutGap="10px">
    <fl-autocomplete
      [placeholder]="'Aircraft Make Model *'"
      [inputControl]="form.controls.aircraftMakeModelId"
      [options]="aircraftMakeModelOptions$ | async"
      (search)="onAircraftMakeModelSearch($event)"
      [useMatInput]="true"
      [errors]="getControlRequiredError(form.controls.aircraftMakeModelId)"
      [initialSelectedItem]="selectedAircraftMakeModel"
    >
    </fl-autocomplete>
  </div>
  <div fxLayout="row" fxLayoutGap="10px">
    <mat-form-field>
      <mat-label>Duty Position</mat-label>
      <mat-select formControlName="dutyPositionType" required>
        <mat-option *ngFor="let option of dutyPositionOptions" [value]="option">
          {{ option }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutGap="10px">
    <mat-form-field>
      <mat-label>Processing State</mat-label>
      <mat-select formControlName="processingState">
        <mat-option
          *ngFor="let option of processingStateOptions"
          [value]="option.value"
          [disabled]="!option.selectable"
        >
          {{ option.value | humanize }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
